var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgKtm = function SvgKtm(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 20,
    viewBox: "0 0 64 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90527 18H14.0576L15.8565 13.5864L19.1647 18H34.5783L39.3465 13.5421L38.5518 18H44.5865L49.5715 13.5886L48.8895 18H55.4002L58.103 5.69409H51.5589L46.2554 10.3862L47.2798 5.69409H41.0046L34.1585 12.5847L37.0202 4.14987H47.4893L47.9691 2H20.5157L19.7116 4.14987H29.8065L25.5534 14.9739L22.199 10.5494L27.9953 5.69409H23.1447L17.1974 10.4682L19.1993 5.69409H12.1106L6.90527 18Z",
    fill: "#F0F0F1"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgKtm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dist/build-client/static/media/KTM.4a9c49ba9f8e5716085ad3ed42f52f3d.svg";